import { render, staticRenderFns } from "./BuscaBeneficiarios.vue?vue&type=template&id=780c22d6"
import script from "./BuscaBeneficiarios.vue?vue&type=script&lang=js"
export * from "./BuscaBeneficiarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports